import { useMutation } from "@tanstack/react-query";
import { registerUser, type RegisterRequest, type RegisterResponse } from "../api/auth.api";
import { ApiError } from "@/lib/api/client";

/**
 * Mutation hook for user registration.
 *
 * On success: returns RegisterResponse (caller shows success UI).
 * On error: returns ApiError with field-level errors.
 */
export function useRegister() {
  return useMutation<RegisterResponse, ApiError, RegisterRequest>({
    mutationFn: registerUser,
  });
}
